<template>
  <v-container fluid>
    <v-layout class="mb-3">
      <v-flex>
        <h3 class="headline mt-0">Reason</h3>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" :loading="loading" @click="showAdd = true">
          <v-icon class="mr-1">add</v-icon> {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-end class="my-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>
    <div v-if="loading" class="text-xs-center py-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else-if="reasons.length == 0">
      <div class="text-xs-center pt-5" style="font-size: 25px">
        <em style="font-size: 50px" class="far fa-folder-open" />
        <br />
        {{ $t('no_data') }}
      </div>
    </template>
    <template v-else>
      <template v-for="(reason, index) in reasons">
        <ReasonItem
          :key="reason.id"
          :reason="reason"
          @updateReason="handleUpdateReason(index, $event)"
          @deleteReason="getReason()"
        />
      </template>
    </template>
    <v-layout row wrap justify-end class="my-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>
    <v-dialog v-model="showAdd" max-width="600px" persistent>
      <ReasonParentManage v-if="showAdd" @onClose="showAdd = false" @onSave="handleAddReason" />
    </v-dialog>
  </v-container>
</template>
<script>
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import reasonApi from '@/api/reason.js'
import { convertReasonRoute } from '@/utils/reason'
import ReasonItem from './ReasonItem.vue'
import ReasonParentManage from './ReasonParentManage.vue'
export default {
  components: {
    ReasonItem,
    ReasonParentManage
  },
  data() {
    return {
      loading: true,
      pageNumber: 1,
      limit: 10,
      total: 0,
      reasons: [],
      showAdd: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageCount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  mounted() {
    this.getReason()
  },
  methods: {
    handleChangePage(page) {
      this.pageNumber = page
      this.getReason()
    },
    async getReason() {
      try {
        this.loading = true
        const response = await reasonApi.getReasonList({
          params: {
            page_id: this.selectedBot.pageid,
            limit: this.limit,
            offset: (this.pageNumber - 1) * this.limit
          }
        })
        const { status, data } = response
        if (status === 200) {
          const list = data.data || []
          this.reasons = list
            ? list.map((reason) => {
                return {
                  ...reason,
                  reason_route: convertReasonRoute(reason.reason_route)
                }
              })
            : []
          this.total = +data.total || 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    },
    async handleUpdateReason(index, reason) {
      this.$set(this.reasons, index, reason)
    },
    async handleAddReason() {
      this.showAdd = false
      this.getReason()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Reason/ReasonList.vue